import React from 'react';
import { Box, Link, Typography } from '@mui/material';

/**
 * Static pages from public/: privacy-policy.html, terms-of-service.html, data-deletion.html
 */
function Sep({ size }) {
  return (
    <Typography component="span" sx={{ fontSize: size, opacity: 0.45, userSelect: 'none' }}>
      |
    </Typography>
  );
}

export default function LegalFooterLinks({ sx = {}, dense = false }) {
  const size = dense ? '0.75rem' : '0.8125rem';
  const linkSx = { fontSize: size, fontWeight: 500 };
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        ...sx,
      }}
    >
      <Link
        href="/privacy-policy.html"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={linkSx}
      >
        Privacy Policy
      </Link>
      <Sep size={size} />
      <Link
        href="/terms-of-service.html"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={linkSx}
      >
        Terms of Service
      </Link>
      <Sep size={size} />
      <Link
        href="/data-deletion.html"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={linkSx}
      >
        User data deletion
      </Link>
    </Box>
  );
}
